import axios from "axios";

export const apiGeneralMail = axios.create({
  baseURL: "https://general.app.paodiario.org.br",
});

export const sendDocumentByEmail = async (emailTo, filename, file) => {
  try {
    const formData = new FormData();
    formData.append("name", emailTo);
    formData.append("filename", filename);
    formData.append("file", file);
    formData.append("email", emailTo);

    const response = await apiGeneralMail.post(
      `users/boleto-financeiro`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    return new Error(error.message);
  }
};
